import React from "react"
import { useSelector } from "react-redux"
import { formSubmissionClosed } from "reduxSlices/formSubmissionSlice"
import { conversationShape } from "utils/propTypeShapes"
import Conversation from "shared/Conversation"

const ConversationListItem = ({ conversation }) => {
  const formSubmissionIsClosed = useSelector(formSubmissionClosed)
  const { closed: conversationIsClosed } = conversation

  return (
    <Conversation
      canAddMessages={!formSubmissionIsClosed && !conversationIsClosed}
      canTakeActions={!formSubmissionIsClosed}
      conversation={conversation}
    />
  )
}

ConversationListItem.propTypes = {
  conversation: conversationShape.isRequired,
}

export default ConversationListItem
